<icn-channel-first-timer *ngIf="isFirstTimer()"></icn-channel-first-timer>
<header class="main-header" *ngIf="!isFirstTimer()">
  <div class="mychannel-header-container">
    <label>CHANNELS</label>
    <!-- <button inlineSVG="/assets/icons/Search-icon.svg"></button> -->
  </div>
</header>
<main *ngIf="!isFirstTimer()">
  <a routerLink="/channels/new" *ngIf="hasPermissionsToCreate">
    <div class="new-channel">
      <div></div>
      <svg width="35px" height="35px" viewBox="0 0 35 35">
        <path
          fill-rule="evenodd"
          d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
        />
      </svg>
      <span>Create New Channel</span>
    </div>
  </a>
  <div
    class="channel"
    *ngFor="let channel of channels"
    (mouseenter)="setCurrentChannel(channel)"
  >
    <div class="hover-layer" #hoverLayer>
      <div
        class="channel-menu-icon"
        [inlineSVG]="menuIcon"
        (click)="onMenuIconClick($event, menuPopover)"
      ></div>
      <div class="buttons">
        <a
          *ngIf="currentUser && currentUser.hasViewSchedulerPermission(channel)"
          [routerLink]="'/scheduler/calendar'"
        >
          <button
            data-name="SCHEDULER"
            inlineSVG="/assets/icons/thum-scheduler.svg"
          ></button>
        </a>
        <a [routerLink]="'/autopilot'">
          <button
            data-name="AUTOPILOT"
            inlineSVG="/assets/icons/thum-autopilot.svg"
          ></button>
        </a>
        <a [routerLink]="'/live'">
          <button
            data-name="LIVE"
            inlineSVG="/assets/icons/thum-live.svg"
          ></button>
        </a>
        <a
          *ngIf="currentUser && currentUser.isSmartPlannerManager"
          [href]="buildSmartScheduleUrl(channel)"
          target="_blank"
        >
          <button
            data-name="SMART PLANNER"
            inlineSVG="/assets/icons/thum-smart.svg"
          ></button>
        </a>
        <pop-over
          #codePopover
          [my]="'top right'"
          [at]="'bottom right'"
          [anchor-to]="hoverLayer"
          [y-offset]="60"
          content-class="channels-dashboard-pop-over"
        >
          <icn-code-popup
            [channel]="channel"
            (closeButtonClicked)="codePopover.hide()"
          ></icn-code-popup>
        </pop-over>

        <pop-over
          #downloadRecordingPopup
          [my]="'top right'"
          [at]="'bottom right'"
          [anchor-to]="hoverLayer"
          [y-offset]="60"
          content-class="channels-dashboard-pop-over"
        >
          <evrideo-download-recording
            #downloadRecordingComponent
            [channel]="channel"
            (closeButtonClicked)="downloadRecordingPopup.hide()"
          ></evrideo-download-recording>
        </pop-over>
      </div>
      <pop-over
        #menuPopover
        [my]="'top right'"
        [at]="'bottom right'"
        [anchor-to]="true"
        [y-offset]="10"
        content-class="channels-dashboard-pop-over"
      >
        <div class="popover-confirmation" *ngIf="needToConfirm">
          <h3>are you sure?</h3>
          <div class="content">
            <p>are you sure you want to turn the channel off?</p>
            <div class="buttons">
              <div
                class="button yes"
                (click)="toggleActiveState(channel, menuPopover)"
              >
                Yes
              </div>
              <div
                class="button no"
                (click)="needToConfirm = false; menuPopover.hide()"
              >
                No
              </div>
            </div>
          </div>
        </div>
        <div class="channel-menu">
          <div
            *ngIf="
              currentUser &&
              currentUser.hasEditChannelSettingsPermission(channel)
            "
            (click)="onEdit(channel, menuPopover)"
          >
            Channel Settings
          </div>
          <div
            (click)="onDelete(channel, menuPopover)"
            *ngIf="hasPermissionsToCreate"
          >
            Delete
          </div>
          <!-- <div (click)="onDuplicate(channel, menuPopover)">Duplicate</div> -->
          <div
            (click)="
              menuPopover.hide();
              codePopover.toggle($event);
              $event.stopImmediatePropagation()
            "
          >
            HLS Link
          </div>
          <div
            (click)="channelToggle(channel, menuPopover)"
            *ngIf="
              currentUser &&
              currentUser.hasActivateDeactivateChannelPermission(channel)
            "
          >
            {{ channel.isActive ? "Deactivate" : "Activate" }} Channel
          </div>
          <div
            class="download-recording"
            (click)="
              menuPopover.hide();
              downloadRecordingComponent.reset();
              downloadRecordingPopup.toggle($event);
              $event.stopImmediatePropagation()
            "
          >
            Download Recording
          </div>
        </div>
      </pop-over>
    </div>
    <div
      [id]="channel.id"
      *ngIf="!channel.isActive"
      class="channel-box"
      [ngStyle]="getChannelBoxStyle(channel)"
    >
      <span class="channel-clock">{{ getChannelTime(channel) }}</span>
    </div>
    <div *ngIf="channel.isActive" class="channel-box">
      <div [id]="channel.id" class="fullscreen-container">
        <video
          #videoElem
          width="100%"
          height="100%"
          [attr.poster]="'/assets/stream-preview-loader.gif'"
          [webrtc-src]="getChannelPreview(channel)"
          (refreshChannelPreview)="onRefreshChannelPreview(channel)"
          [muted]="channel.isMuted"
          autoplay
        ></video>

        <!-- <div *ngIf="showQualitySettings && isFullScreen(channel.id)" class="quality-settings-fullscreen">
                    <div *ngFor="let quality of getAvailableQualities(channel)" class="single-quality-container">
                        <div [ngStyle]="{'visibility': isChosenQuality(quality, channel) ? 'visible' : 'hidden'}" class="success" inlineSVG="/assets/icons/success.svg"></div>
                        <div class="quality" (click)="changeQuality(quality, channel)">{{quality}}</div>
                    </div>
                </div> -->

        <div class="custom-video-controls" *ngIf="isFullScreen(channel.id)">
          <div class="controls">
            <div class="controls-left">
              <div
                *ngIf="isPaused()"
                class="play"
                inlineSVG="/assets/icons/play.svg"
                (click)="togglePlay()"
              ></div>
              <div
                *ngIf="!isPaused()"
                class="play"
                inlineSVG="/assets/icons/pause.svg"
                (click)="togglePlay()"
              ></div>
              <div
                *ngIf="!isMuted(channel)"
                class="sound"
                inlineSVG="/assets/icons/sound.svg"
                (click)="toggleMute(channel)"
              ></div>
              <div
                *ngIf="isMuted(channel)"
                class="muted"
                inlineSVG="/assets/icons/muted.svg"
                (click)="toggleMute(channel)"
              ></div>
            </div>
            <div class="controls-right">
              <!-- <div class="settings" inlineSVG="/assets/icons/settings.svg" (click)="showQualitySettings = !showQualitySettings; changeDetectorRef.markForCheck()"></div> -->
              <div
                class="fullscreen"
                inlineSVG="/assets/icons/exit-fullscreen.svg"
                (click)="exitFullscreen()"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <span class="channel-clock">{{ getChannelTime(channel) }}</span>
      <button
        [inlineSVG]="getSvg(channel)"
        (click)="toggleMute(channel)"
      ></button>
    </div>
    <div class="channel-info">
      <div class="led-box">
        <div class="indicator" *ngIf="channel.isActive">
          <div class="led-red"></div>
        </div>
        <div class="indicator" *ngIf="!channel.isActive">
          <div class="led-blue"></div>
        </div>
      </div>
      <div class="date-name-container">
        <span class="date">{{ formatDate(channel) }}</span>
        <span>{{ channel.name }}</span>
      </div>
      <div class="full-screen-button" (click)="enterFullscreen(channel)">
        <div
          class="full-screen-svg"
          inlineSVG="/assets/icons/Player-large-preview.svg"
        ></div>
      </div>
    </div>
  </div>
</main>
